import "./utilities_namespace.js";

// Utility for converting nested object keys between cases
(function () {
  // Returns a new object with camelCaseKeys
  Sparkle.Utilities.snakeToCamelObject = function (data) {
    return convertObject(data, Sparkle.Utilities.snakeToCamelCase);
  };

  // Returns a new object with snake_case_keys
  Sparkle.Utilities.camelToSnakeObject = function (data) {
    return convertObject(data, Sparkle.Utilities.camelToSnakeCase);
  };

  Sparkle.Utilities.snakeToCamelCase = function (string) {
    return string.replace(/_./g, (match) => match[1].toUpperCase());
  };

  Sparkle.Utilities.camelToSnakeCase = function (string) {
    return string.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase();
  };

  function convertObject(object, converter) {
    if (object == null) {
      return object;
    }

    var targetObject;

    if (isArray(object)) {
      targetObject = [];
    } else if (isPlainObject(object)) {
      targetObject = {};
    } else {
      return object;
    }

    Object.keys(object).forEach((key) => {
      var currentObject = object[key];
      var newKey = converter(key);
      currentObject = convertObject(currentObject, converter);
      targetObject[newKey] = currentObject;
    });

    return targetObject;
  }

  function isPlainObject(obj) {
    return obj.constructor.name == "Object";
  }

  function isArray(obj) {
    return obj.constructor.name == "Array";
  }
})();
